import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Switch } from "./ui/switch";

export default function AnnouncementEmailPref() {
  const [on, setOn] = useState(null);

  useEffect(() => {
    api.get("/announcements/preferences").then(({ data }) => setOn(data.announcement_emails)).catch(() => {});
  }, []);

  const change = async (v) => {
    setOn(v);
    try {
      await api.put("/announcements/preferences", { announcement_emails: v });
      toast.success(v ? "Announcement emails on" : "Announcement emails off");
    } catch { setOn(!v); toast.error("Couldn't save — try again"); }
  };

  if (on === null) return null;

  return (
    <section className="card-base p-5 flex items-start gap-3" data-testid="announcement-email-pref">
      <div className="w-10 h-10 rounded-xl bg-sage-100 text-sage-600 grid place-items-center shrink-0"><Megaphone size={18} /></div>
      <div className="flex-1">
        <h2 className="font-heading font-semibold">Announcement emails</h2>
        <p className="text-sm text-ink-600">Occasional news from AMDS. Dep requests, booking and account emails always arrive.</p>
      </div>
      <Switch checked={on} onCheckedChange={change} data-testid="announcement-email-switch" />
    </section>
  );
}
